module.exports = __webpack_public_path__ + "img/专业团队顶级赋能.24e907a2.gif";